import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

// Components
import Layout from './components/common/Layout';
import LoginPage from './components/pages/LoginPage';
import AppointmentsPage from './components/pages/AppointmentsPage';
import PricingPage from './components/pages/PricingPage';
import DatesPage from './components/pages/DatesPage';
import CustomPaymentsPage from './components/pages/CustomPaymentsPage';

// Store
import { useAuthStore } from './store/authStore';

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

// Public Route Component (redirect to dashboard if already logged in)
const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  return !isAuthenticated ? <>{children}</> : <Navigate to="/appointments" replace />;
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route 
            path="/login" 
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            } 
          />

          {/* Protected Routes */}
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <Layout>
                  <Navigate to="/appointments" replace />
                </Layout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/appointments" 
            element={
              <ProtectedRoute>
                <Layout>
                  <AppointmentsPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/pricing" 
            element={
              <ProtectedRoute>
                <Layout>
                  <PricingPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/dates" 
            element={
              <ProtectedRoute>
                <Layout>
                  <DatesPage />
                </Layout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/custom-payments" 
            element={
              <ProtectedRoute>
                <Layout>
                  <CustomPaymentsPage />
                </Layout>
              </ProtectedRoute>
            } 
          />

          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/appointments" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;